import { render, staticRenderFns } from "./Organization.vue?vue&type=template&id=46c9d3a2"
import script from "./Organization.vue?vue&type=script&lang=ts"
export * from "./Organization.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports